import Select from 'react-select';

const AssessmentSelect = ({ value, setValue, options, isDisabled }) => {
    return (
        <Select
            styles={{ control: (styles) => ({ ...styles, width: '100px' }) }}
            isDisabled={isDisabled}
            options={options}
            onChange={setValue}
            value={value ? { label: value, value } : null}
        />
    );
};

export default AssessmentSelect;
